export enum MeritBudgetComponentCalculationType {
  Delta = 'Delta',
  PercentageOfBase = 'PercentageOfBase',
  Total = 'Total',
  NoIncrease = 'NoIncrease'
}
